import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureResultState } from '../type/ai-disclosure.type';

export const AIDisclosureResultModel = Symbol('AIDisclosureResultModel');

export type AIDisclosureResultModel = AbstractModel<AIDisclosureResultState>

@injectable()
export class AIDisclosureResultModelImpl extends AbstractModel<AIDisclosureResultState> implements AIDisclosureResultModel {
    protected _modelData: AIDisclosureResultState = {
        title: '',
        settings: {
            inventionSubject: [],
            applicationField: [],
            techMeans: '',
            techEffect: '',
            other: '',
            recommendInventionSubject: [],
            recommendApplicationField: [],
        },
        hidden: [],
        disclosureResult: [],
    };
}
